export default __webpack_public_path__ + "static/media/portfolio-1.5b6dea54.jpg";